import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CompanyService } from '@app/shared/services/company.service';
import { MatomoService } from '@app/shared/services/matomo.service';
import { TranslocoService } from '@ngneat/transloco';
import { HashMap } from '@ngneat/transloco/lib/types';
import { Transition, TransitionService } from '@uirouter/angular';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  private defaultTitle = '';
  private unreadCount = 0;
  private currentTitle = '';

  constructor(
    private $transitions: TransitionService,
    private companyService: CompanyService,
    private paq: MatomoService,
    private title: Title,
    private translocoService: TranslocoService
  ) {}

  private get suffix() {
    return this.companyService.data?.name ? `| ${this.companyService.data?.name}` : '';
  }

  init() {
    this.defaultTitle = this.title.getTitle();

    this.$transitions.onSuccess({}, (transition: Transition) => {
      const to = transition.to();
      const title = to.data?.title;
      const ignoreStateAsTitle = to.data?.ignoreStateAsTitle;

      if (!ignoreStateAsTitle && !title) {
        this.setTitleFromStateName(to.name as string);
      } else if (title) {
        this.setTitle(title);
      }
    });
  }

  // Sets title from translation key
  setTitle(key: string, params?: HashMap) {
    this.translocoService.selectTranslate(key, params).subscribe(translation => {
      // use default title when there is no translation for key
      this.changeDocumentTitle(
        `${translation !== '' && key !== translation ? translation : this.defaultTitle} ${this.suffix}`
      );
    });
  }

  // Sets title from raw text
  setTitleText(text: string) {
    this.changeDocumentTitle(`${text} ${this.suffix}`);
  }

  setTitleFromStateName(stateName: string) {
    this.setTitle(`page-titles.${stateName}`);
  }

  setUnreadNotificationsCount(count: number) {
    this.unreadCount = count;
    this.changeDocumentTitle(this.currentTitle, false);
  }

  private changeDocumentTitle(title: string, saveCurrentTitle = true) {
    if (saveCurrentTitle) {
      this.currentTitle = title;
    }

    if (this.unreadCount > 0) {
      this.title.setTitle(`(${this.unreadCount}) ${title}`);
    } else {
      this.title.setTitle(title);
    }

    // Send paq message
    this.paq.push('setDocumentTitle', title);
  }
}
